import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Typography, Descriptions } from 'antd';
import { CopyIcon } from 'utils/icons';
import currencyFormat from 'utils/currencyFormat';
import dayjs from 'dayjs';
import EbzDrawer from 'components/EbzDrawer/EbzDrawer';

function TransactionDetailsDrawer({
  productList,
  viewMoreModal,
  currentView,
  handleViewDetails,
  toggleModal
}) {
  const easebuzzIdFormatter = (value) => (
    <Typography.Text
      copyable={{
        text: value,
        icon: <CopyIcon style={{ color: 'var(--color-primary)' }} />
      }}
      style={{ fontSize: '16px' }}
    >
      {value}
    </Typography.Text>
  );
  const detailsItems = [
    {
      label: 'Easebuzz ID',
      key: 'app_transaction_id',
      formatter: (value) => easebuzzIdFormatter(value)
    },
    {
      label: 'Transaction Date',
      key: 'transaction_ist_date',
      formatter: (value) => dayjs(value).format('DD MMM, YYYY')
    },
    {
      label: 'Product',
      key: 'app_name',
      formatter: (value) => productList[value]?.label
    },
    {
      label: 'Amount',
      key: 'transaction_amount',
      formatter: (value) => currencyFormat(value, true, true)
    },
    {
      label: 'Commission Mode',
      key: 'commission_type'
    },
    {
      label: 'Commission Value',
      key: 'commission',
      formatter: (value) => parseFloat(value).toFixed(2)
    },
    {
      label: 'Commission Amount',
      key: 'commission_amount',
      formatter: (value) => currencyFormat(value, true, true)
    },
    {
      label: 'Service Charge',
      key: 'transaction_markup_charge',
      formatter: (value) => currencyFormat(value, true, true)
    },
    {
      label: 'Service Tax',
      key: 'transaction_markup_charge_tax',
      formatter: (value) => currencyFormat(value, true, true)
    },
    {
      label: 'Settlement Amount',
      key: 'merchant_settlement_amount',
      formatter: (value) => currencyFormat(value, true, true)
    }
  ];

  const merchantSpecificParameters = [
    {
      label: 'UDF 1',
      key: 'udf1'
    },
    {
      label: 'UDF 2',
      key: 'udf2'
    },
    {
      label: 'UDF 3',
      key: 'udf3'
    },
    {
      label: 'UDF 4',
      key: 'udf4'
    },
    {
      label: 'UDF 5',
      key: 'udf5'
    },
    {
      label: 'UDF 6',
      key: 'udf6'
    },
    {
      label: 'UDF 7',
      key: 'udf7'
    },
    {
      label: 'UDF 8',
      key: 'udf8'
    },
    {
      label: 'UDF 9',
      key: 'udf9'
    },
    {
      label: 'UDF 10',
      key: 'udf10'
    }
  ];

  const renderDescriptionItems = (items) => {
    return items.map((item) => {
      const formatted = item.formatter
        ? item.formatter(currentView?.[item.key])
        : currentView?.[item.key];

      return (
        <Descriptions.Item
          key={item.key}
          label={<Typography.Text style={{ fontWeight: 700 }}>{item.label}</Typography.Text>}
        >
          {formatted || '-'}
        </Descriptions.Item>
      );
    });
  };

  return (
    <EbzDrawer
      title={
        <Row>
          <Col span={24}>
            <Typography.Text style={{ fontSize: '16px', color: 'var(--color-primary)' }}>
              Transaction Details
            </Typography.Text>
          </Col>
        </Row>
      }
      handleViewDetails={handleViewDetails}
      viewMoreModal={viewMoreModal}
      toggleModal={toggleModal}
    >
      <Row>
        <Col span={24}>
          <Descriptions
            size="small"
            bordered
            column={1}
            style={{ marginTop: '20px' }}
            labelStyle={{ backgroundColor: '#FFFFFF' }}
          >
            {renderDescriptionItems(detailsItems)}
          </Descriptions>

          <Descriptions
            title={
              <Typography.Text style={{ fontSize: '16px', color: 'var(--color-primary)' }}>
                Merchant Specific Parameters
              </Typography.Text>
            }
            size="small"
            bordered
            column={1}
            style={{ marginTop: '20px' }}
            labelStyle={{ backgroundColor: '#FFFFFF' }}
          >
            {renderDescriptionItems(merchantSpecificParameters)}
          </Descriptions>
        </Col>
      </Row>
    </EbzDrawer>
  );
}

TransactionDetailsDrawer.propTypes = {
  viewMoreModal: PropTypes.bool.isRequired,
  productList: PropTypes.instanceOf(Object).isRequired,
  currentView: PropTypes.instanceOf(Object).isRequired,
  handleViewDetails: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired
};

export default TransactionDetailsDrawer;
